import { BaseUrlController } from '../base-client/base-url-controller';
import { EEnvironment } from '@/entities';

const baseUrlController = new BaseUrlController({
  baseUrlEnvKey: 'VITE_APP_API_BASE_URL_KE_GATEWAY',
});
baseUrlController.add(EEnvironment.RELEASE, 'https://api.uat.cluster.kznexpess.com/api');
baseUrlController.add(EEnvironment.DEVELOPMENT, 'https://api.dev.cluster.kznexpess.com/api');
baseUrlController.add(EEnvironment.PRODUCTION, 'https://api.kazanexpress.ru/api');

export class KEGatewayConfig {
  static DEFAULT_HEADERS = {};

  static getBaseUrl() {
    return baseUrlController.getBaseUrl();
  }
}
